import React, {useState} from "react";
import {CodeOutlined, CopyOutlined, DownOutlined} from "@ant-design/icons";
import {Button, ButtonVariants, Text, TextAs, TextSizes} from "@clockout-dev/design-elements";
import SectionCard from "../../common/sectionCard/SectionCard";
import styles from "../styles/results.module.scss";

/**
 * Collapsed-by-default raw JSON viewer: scrollable monospace `<pre>` plus a
 * copy button that hands the data back to the page (which owns the clipboard
 * write + messageApi toast).
 *
 * @param {Object} props
 * @param {string} props.title
 * @param {*} props.data — anything JSON-serializable
 * @param {(data: *) => void} props.onCopy
 */
function JsonViewerCard({title, data, onCopy}) {
    const [expanded, setExpanded] = useState(false);
    if (data === null || data === undefined) return null;

    let serialized = "";
    try {
        serialized = JSON.stringify(data, null, 2);
    } catch (error) {
        serialized = String(data);
    }

    return (
        <SectionCard
            icon={<CodeOutlined />}
            title={title}
            action={
                <div className={styles.jsonActions}>
                    <Button variant={ButtonVariants.TEXT} className={styles.jsonActionButton} aria-label={`Copy ${title}`} onClick={() => onCopy(data)}>
                        <CopyOutlined />
                    </Button>
                    <Button
                        variant={ButtonVariants.TEXT}
                        className={styles.jsonActionButton}
                        aria-label={expanded ? `Collapse ${title}` : `Expand ${title}`}
                        onClick={() => setExpanded(previous => !previous)}>
                        <DownOutlined className={expanded ? styles.jsonChevronOpen : styles.jsonChevron} />
                    </Button>
                </div>
            }>
            {expanded ? (
                <pre className={styles.jsonPre}>{serialized}</pre>
            ) : (
                <Text as={TextAs.P} size={TextSizes.EXTRA_SMALL} className={styles.emptyNote}>
                    {Math.max(1, Math.round(serialized.length / 1024))}KB of JSON — expand to inspect or copy it raw.
                </Text>
            )}
        </SectionCard>
    );
}

export default JsonViewerCard;
